import { render, staticRenderFns } from "./BaseLabelWithFlag.vue?vue&type=template&id=6053030e&scoped=true&"
import script from "./BaseLabelWithFlag.vue?vue&type=script&lang=js&"
export * from "./BaseLabelWithFlag.vue?vue&type=script&lang=js&"
import style0 from "./BaseLabelWithFlag.vue?vue&type=style&index=0&id=6053030e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6053030e",
  null
  
)

export default component.exports